import styled from "styled-components";
import Row from "../Shared/Kit/Row";
import Col from "../Shared/Kit/Col";
import { HexToRgba } from "../Methods/HexToRgba";

export const SectionWrapper = styled(Col)`//index
    position: relative;
    width: 100vw;
    height: 100vh;
    background-image: url(${(props) => props.source});
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
    .layer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(${(props) => props.layerSource});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 0;
    }
    .content {
        position: relative;
        height: 100%;
        margin: 0 auto;
        z-index: 1;
    }
`
//استایل صفحات به جز index & about us
export const Wrapper = styled(Col)`
    width: 100vw;
    min-height: 100vh;
    background-color: ${(props) => HexToRgba(props.theme.gray, 0.04)};
    justify-content: flex-start;
    padding-top: 150px;
    .header {
        background-color: ${(props) => props.theme.white};
    }
    .section {
        :first-child {
            /* margin: 0 0 50px 0; */
            margin: 0;
        }
        :last-child {
            // margin: 50px 0 150px 0;
            margin: 10px 0 250px 0;
        }
        // margin: 50px 0;
        margin: 10px 0;
    }
    &.white-bg {
        /* background-color: ${(props) => props.theme.white}; */
    }
`
export const Title = styled(Row)`
    font-size: ${(props) => props.theme.fontSizeMd2};
    font-weight: bold;
    color: ${(props) => props.theme.gray};
    margin-bottom: 30px;
    ::before {
        content: "";
        width: 120px;
        height: 1px;
        background-color: ${(props) => props.theme.secondary};
        margin-left: 20px;
    }
    /* ::after {
        content: "";
        width: 1px;
        height: 25px;
        background-color: ${(props) => props.theme.secondary};
        margin-right: 25px;
    } */
`
export const ItemsContainer = styled(Row)`
 border:thin solid #dddddd;
`
export const Item = styled(Row)`
    /* font-size: ${(props) => props.theme.fontSizeMd1}; */
    font-size: 15px;
    color: ${(props) => props.theme.gray};
    margin-bottom: 25px;
    .bullet {
        width: 8px;
        height: 8px;
        margin-left: 8px; 
        border-radius: 50%;
        background-color: ${(props) => props.theme.secondary};
    }
    .title {
        font-weight: bold;
        margin-bottom: 10px;
    }
`;
export const DescriptionAndImage = styled(Row)`
    align-items: flex-start;
    > div:first-child {
        width: calc(100% - 500px);
    }
`
export const ImageContainer = styled(Row)`
    width: 500px;
    margin-top: 60px;
`
export const Image = styled(Col)`
    height: ${(props) => props.height || "340px"};
    background-image: url(${(props) => props.source});
    background-size: contain;
    background-position: left top;
    background-repeat: no-repeat;
`
export const LinkStyle = styled.a`
    display: flex;
    align-items: center;
    width: 100%;
    font-size: ${(props) => props.theme.fontSizeMd1};
    color: ${(props) => props.theme.secondary};
    text-align: justify;
    margin-bottom: 10px;
    :last-child {
        margin-bottom: 0;
    }
    &.download {
        margin-top: 10px;
        svg {
            width: 20px;
            height: 20px;
            fill: ${(props) => props.theme.secondary};
            margin-right: 8px;
            margin-top: -3px;
        }
    }
    &.link {
        svg {
            width: 15px;
            height: 15px;
            fill: ${(props) => props.theme.secondary};
            margin-left: 8px;
            margin-top: -3px;
        }
    }
    @media screen and (max-width: 1366px) {
        font-size: 15px;
        svg {
            scale: 0.95;
        }
    }
`
export const CancellationInvestmentImage = styled(Col) && styled.a`
    width: 450px;
    height: 500px;
    background-image: url(${(props) => props.source});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
`